import 'primeflex/primeflex.css';
import 'typeface-roboto/index.css';
import 'primevue/resources/primevue.min.css';
import 'primevue/resources/themes/saga-blue/theme.css';
import 'primeicons/primeicons.css';

import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import PrimeVue from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';

/* PrimeVue components */
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import Card from 'primevue/card';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import Password from 'primevue/password';
import RadioButton from 'primevue/radiobutton';
import Checkbox from 'primevue/checkbox';
import Calendar from 'primevue/calendar';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Panel from 'primevue/panel';
import Toast from 'primevue/toast';
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Dropdown from 'primevue/dropdown';
import Menubar from 'primevue/menubar';
import Message from 'primevue/message';
import ConfirmPopup from 'primevue/confirmpopup';
import ConfirmDialog from 'primevue/confirmdialog';
import Textarea from 'primevue/textarea';
import ProgressSpinner from 'primevue/progressspinner';
import FileUpload from 'primevue/fileupload';
import Chip from 'primevue/chip';
import ProgressBar from 'primevue/progressbar';
import MultiSelect from 'primevue/multiselect';
import TreeTable from 'primevue/treetable';
import Rating from 'primevue/rating';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import DataView from 'primevue/dataview';
import Splitter from 'primevue/splitter';
import SplitterPanel from 'primevue/splitterpanel';
import InputMask from 'primevue/inputmask';
import TabMenu from 'primevue/tabmenu';

/* Video player Vue 3 */
import 'vue3-video-play/dist/style.css';

const app = createApp(App);

app
    .use(store)
    .use(router)
    .use(PrimeVue, {
            locale: {
                    clear: 'Xoá',
                    accept: 'Có',
                    reject: 'Không',
                    today: 'Hôm nay',
                    choose: 'Chọn',
                    upload: 'Upload',
                    cancel: 'Huỷ'
            }
    })
    .use(ConfirmationService)
    .use(ToastService);

/* Global components */
app.component('Button', Button);
app.component('Dialog', Dialog);
app.component('Card', Card);
app.component('InputText', InputText);
app.component('InputNumber', InputNumber);
app.component('Password', Password);
app.component('RadioButton', RadioButton);
app.component('Checkbox', Checkbox);
app.component('Calendar', Calendar);
app.component('DataTable', DataTable);
app.component('Column', Column);
app.component('Panel', Panel);
app.component('Toast', Toast);
app.component('TabView', TabView);
app.component('TabPanel', TabPanel);
app.component('Dropdown', Dropdown);
app.component('Menubar', Menubar);
app.component('Message', Message);
app.component('ConfirmPopup', ConfirmPopup);
app.component('ConfirmDialog', ConfirmDialog);
app.component('Textarea', Textarea);
app.component('ProgressSpinner', ProgressSpinner);
app.component('FileUpload', FileUpload);
app.component('Chip', Chip);
app.component('ProgressBar', ProgressBar);
app.component('MultiSelect', MultiSelect);
app.component('TreeTable', TreeTable);
app.component('Rating', Rating);
app.component('Accordion', Accordion);
app.component('AccordionTab', AccordionTab);
app.component('DataView', DataView);
app.component('Splitter', Splitter);
app.component('SplitterPanel', SplitterPanel);
app.component('InputMask', InputMask);
app.component('TabMenu', TabMenu);

app.mount('#app');
